import Navigation from "@/components/navigation/navigation";

export default function NavHeader(){
    return (
        <Navigation />
    )
}